const { Core, Events } = Global;

const PRESSED_CLASS = '!pressed';
const ADDED_CLASS = '!added';
const LOADING_CLASS = '!loading';

if (!customElements.get('doto-carousel-quick-add')) {
  customElements.define('doto-carousel-quick-add', class extends Core {
    render() {
      this.pending = false;
      this.resetTimer = null;
      this.button = this.querySelector('[data-doto-carousel-quick-add-button]');

      if (!this.button || this.button.disabled) return;

      this.button.addEventListener('click', this._handleClick.bind(this));
      this.sub(Events.CART_UPDATE, this._handleCartUpdate, { global: true });
      this.sub(Events.CART_ERROR, this._handleCartError, { global: true });
    }

    disconnectedCallback() {
      window.clearTimeout(this.resetTimer);
      if (super.disconnectedCallback) super.disconnectedCallback();
    }

    _handleClick(event) {
      event.preventDefault();
      event.stopPropagation();

      if (this.pending) return;

      const variantId = Number(this.dataset.variantId);
      if (!variantId) return;

      this.pending = true;
      this.classList.remove(ADDED_CLASS);
      this.classList.remove(PRESSED_CLASS);
      this.button.classList.add(LOADING_CLASS);

      void this.offsetWidth;
      this.classList.add(PRESSED_CLASS);

      window.setTimeout(() => {
        this.classList.remove(PRESSED_CLASS);
      }, 300);

      this.pub(Events.CART_ADD, {
        items: [
          {
            id: variantId,
            quantity: 1
          }
        ]
      });
    }

    _handleCartUpdate({ req }) {
      if (!this.pending || req !== 'cartAdd') return;

      this.pending = false;
      this.button.classList.remove(LOADING_CLASS);
      this.classList.add(ADDED_CLASS);

      window.clearTimeout(this.resetTimer);
      this.resetTimer = window.setTimeout(() => {
        this.classList.remove(ADDED_CLASS);
      }, 900);
    }

    _handleCartError() {
      if (!this.pending) return;

      this.pending = false;
      this.button.classList.remove(LOADING_CLASS);
      this.classList.remove(PRESSED_CLASS, ADDED_CLASS);
    }
  });
}
